import { render, staticRenderFns } from "./СarBodyTypes.vue?vue&type=template&id=654f774a&scoped=true"
import script from "./СarBodyTypes.vue?vue&type=script&lang=js"
export * from "./СarBodyTypes.vue?vue&type=script&lang=js"
import style0 from "./СarBodyTypes.vue?vue&type=style&index=0&id=654f774a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f774a",
  null
  
)

export default component.exports